import { render } from "./ModalNuovoIntervento.vue?vue&type=template&id=ab467070&scoped=true"
import script from "./ModalNuovoIntervento.vue?vue&type=script&lang=js"
export * from "./ModalNuovoIntervento.vue?vue&type=script&lang=js"

import "./ModalNuovoIntervento.vue?vue&type=style&index=0&id=ab467070&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_perla_1768301730385742645/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab467070"]])

export default __exports__